import React from 'react'
import Button from './Button'

class CTA extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <section className="section section--blueGradient">
        <div className="container">
          <div className="section__head">
              <h2>Get started</h2>
              <p>Administrators and players can create accounts and start the school approval process. Once your school is verified, get ready to lead your team to victory!</p>
          </div>
          <div className="section__CTA">
            <Button
              type="button"
              className="btn btn__reverse"
              text="Request to coach"
              onClick={this.joinAsCoach}
            />
            <Button
              type="button"
              className="btn btn__primary"
              text="Sign up to play"
              onClick={this.joinAsPlayer}
            />
          </div>
        </div>
      </section>
    )
  }
}

export default CTA



// WEBPACK FOOTER //
// ./src/common/ui/components/cta.js